<template>
    <div>
        <b-card no-body>
            <template v-if="enable_edit" #header>
                <div class="d-flex">
                    <span class="pt-1">
                        <i class="fas fa-exclamation me-3"></i>
                        <strong>Admin override is enabled for this table</strong>
                    </span>
                    <b-button @click="saveTable()" class="ms-auto me-2" size="sm" variant="success">
                        <i class="fas fa-save me-1"></i>
                        Save
                    </b-button>
                    <b-button @click="insertBlankRow()" size="sm" variant="primary">
                        <i class="fas fa-plus me-1"></i>
                        Insert Empty Row
                    </b-button>
                </div>
            </template>
            <b-alert class="mt-3" :show="enable_edit == false && log_data.length == 0" dismissible>
                No Distribution Log Data Found
            </b-alert>
            <webix-ui v-if="show_table" :config="ui" v-model="log_data"></webix-ui>
            <div v-if="show_table"  class="d-flex">
                <div style="width: 100%; height: 100%;" id="distributionLogsPager"></div>
                <!-- <b-button variant="primary" class="mt-1 w-xs"  style="padding-top: 1px; padding-bottom: 1px;" size="sm">
                    <i class="fas fa-pen me-1"/>
                    Edit
                </b-button> -->
            </div>
            <b-overlay :show="is_loading" no-wrap></b-overlay>
        </b-card>
    </div>
</template>

<script>
import { sopState, sopMethods, clientAdminState, clientAdminMethods } from "@/state/helpers";
import { cloneDeep } from 'lodash';
export default {
    data:() => ({
        is_loading: false,
    }),
    watch:{
        enable_edit(newVal){
            //update webix config if admin override changes
            window.webix.$$('distributionLogsTable').define('editable', newVal);

            //* show/hide delete col
            if(newVal){
                window.webix.$$('distributionLogsTable').showColumn('delete');
            }
            else{
                window.webix.$$('distributionLogsTable').hideColumn('delete');
            }
        },
    },
    computed:{
        ...clientAdminState,
        ...sopState,
        show_table(){
            return this.has_all_level_users;
        },
        has_all_level_users(){
            return this.all_users != null;
        },
        enable_edit(){
            return this.sop_data && this.sop_data.admin_override;
        },
        userdropdown_user_list(){
            if(this.has_all_level_users){
                let users = this.all_users.map( item => {
                    return {
                        id: item.id,
                        value: item.name
                    }
                })
                users.push({
                    id: '-1',
                    value: '** User Required **'
                });
                return users;
            }
            else{
                return [{
                    id: '-1',
                    value: '** User Required **',
                }]
            }
        },
        ui(){
            let el = this;
            let config = {
                view: 'datatable',
                id: 'distributionLogsTable',
                css:"webix_data_border webix_header_border",
                autoheight: true,
                fillspace: true,
                editable: this.enable_edit, 
                columns:[
                    { id: 'delete', width: 35, header: '', hidden: !el.enable_edit,
                        template(){
                            return `<i class="fas fa-trash delete_action"></i>`
                        }
                    },
                    { id: 'copy_no', editor: 'text', header:'Copy No',width: 100},
                    { id: 'copy_type',  editor: 'combo',
                        options: [{id: 'controlled', value:'Controlled'}, {id:'uncontrolled', value:'Uncontrolled'}],
                        header:'Copy Type', width: 120},
                    {
                        id: 'release_user_id',  header: 'Release User', width: 200, editor: "combo",
                        options: el.userdropdown_user_list,
                        suggest:{
                            view:"suggest",
                            body:{
                                view:"list",
                                data:el.userdropdown_user_list,
                                template:"#value#",
                                yCount:10
                            }
                        },
                    },
                    { id: 'copy_holder_name', header: 'Copy Holder Name', editor: 'text', width: 150},
                    { id: 'copy_holder_email', header: 'Copy Holder Email', editor: 'text', width: 150},
                    { id: 'reason_for_copy', editor: 'popup', header:'Reason For Copy', fillspace: true},
                ],
                pager:{
                    template:"{common.prev()} {common.pages()} {common.next()}",
                    container:"distributionLogsPager",
                    size:15,
                    group:5
                },
                on:{
                    onAfterEditStop(state, target){
                        let id = target.row;
                        let item = this.getItem(id);
                        if((state.old == undefined || state.old == '') && state.value){
                            // logic for flagging new rows
                            if(item.is_empty != undefined){
                                delete item.is_empty;
                                this.updateItem(id, item);
                                this.refresh();
                            }
                        }
                    }
                },
                onClick:{
                    //eslint-disable-next-line
                    'delete_action'(id, e){
                        // don t show prompt for empty rows
                        if(e.is_empty){
                            this.remove(e.row);
                            return;
                        }
                        el.$swal.fire({
                            title:'Delete Row?'
                        })
                        .then((result) => {
                            if(result.isConfirmed){
                                this.remove(e.row);
                            }
                        })
                    }
                }
            }
            return config;
        },
        log_data(){
            if(this.sop_data && this.sop_data.distribution_log && Array.isArray(this.sop_data.distribution_log)){
                // clone to prevent vuex mutation error
                return cloneDeep(this.sop_data.distribution_log);
            }
            else{
                return [];
            }
        }
    },
    methods:{
        ...clientAdminMethods,
        ...sopMethods,
        saveTable(){
            this.is_loading = true;
            let table_rows = window.webix.$$('distributionLogsTable').serialize();
            table_rows = table_rows.filter( item => { return item.is_empty == undefined });
            table_rows.forEach( item => {
                if(item.is_new_row){
                    item.id = -1;
                }
            });

            let save_params = {
                distribution_logs: table_rows,
                client_sop_type_id: this.sop_data.id,
            }
            
            this.saveSopDistributionLog(save_params)
            .then(()=>{
                this.loadSopData(this.sop_data.id);
                this.is_loading = false;

                this.$swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'success',
                    icon: 'success',
                    title:'Saved!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            })
            .catch(()=>{
                this.$swal.fire('An error occured while saving');
                this.is_loading = false;
            })
        },
        insertBlankRow(){
            window.webix.$$('distributionLogsTable').add({
                id: window.webix.uid(),
                is_new_row: true,
                is_empty: true,
                release_user_id: -1,
                copy_type: '',
                reason_for_copy: '',
                copy_no: '',
                copy_holder_name : '',
                copy_holder_email: '',
            })
        },
    },
    mounted(){
        if(this.has_all_level_users == false){
            this.loadLevelUsers(-1);
        }
    }
}
</script>

<style>
.webix_pager{
    width: 100% !important;
}
</style>